:host {
  display: block;
}

.youtube-player {
  position: relative;
  width: 100%;
  height: 100%;
  padding-top: 56.25%;

  iframe {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  .play-button-control {
    height: 3rem;
    width: 3rem;
    padding: .5rem 0 0 .5rem;
    fill: white;
    cursor: pointer;
  }

  .controls {
    display: flex;
    background: #ddd;
    height: 2.8rem;
  }

  .progress-bar-container {
    width: 100%;
    display: block;

    .progress-bar {
      width: 97%;
    }

    div.progress-bar {
      position: relative;
      display: block;
      background-color: #ccc;
      box-shadow: .25rem .25rem .25rem inset rgba(0, 0, 0, .5);
      height: .25rem;
      cursor: pointer;
      margin-left: 1%;
      top: 1.3rem;
      pointer-events: none;

      & > div {
        height: .25rem;
        background: white;
        transition: all .1s linear;
      }
    }

    input.progress-bar {
      cursor: pointer;
      margin-top: .8rem;
      margin-left: 1%;
      /* Style for input */
      -webkit-appearance: none;
      appearance: none;
      background: transparent;
    }

    input.progress-bar:focus {
      outline: none;
    }

    input.progress-bar::-ms-track {
      width: 100%;
      cursor: pointer;

      /* Hides the slider so custom styles can be added */
      background: transparent;
      border-color: transparent;
      color: transparent;
    }

    input.progress-bar::-webkit-slider-thumb {
      -webkit-appearance: none;
      height: 1.25rem;
      width: 1rem;
      cursor: pointer;
      margin-top: -.25rem; /* You need to specify a margin in Chrome */
      box-shadow: none;
    }

    input.progress-bar::-moz-range-thumb {
      -webkit-appearance: none;
      border: none;
      height: 1rem;
      width: .25rem;
      cursor: pointer;
      box-shadow: none;
      background: transparent;
    }

    input.progress-bar::-webkit-slider-runnable-track {
      width: 100%;
      height: .625rem;
      cursor: pointer;
      background: transparent;
    }

    input.progress-bar:focus::-webkit-slider-runnable-track {
      background: transparent;
    }

    input.progress-bar::-moz-range-track {
      width: 100%;
      height: .625rem;
      cursor: pointer;
      background: transparent;
    }

    input.progress-bar:focus::-moz-range-track {
      outline: none;
    }

    input.progress-bar::-ms-track {
      width: 100%;
      height: .625rem;
      cursor: pointer;
      background: transparent;
      color: transparent;
    }

    input.progress-bar::-ms-fill-lower {
      background: transparent;
    }

    input.progress-bar:focus::-ms-fill-lower {
      background: transparent;
    }

    input.progress-bar::-ms-fill-upper {
      background: transparent;
    }

    input.progress-bar:focus::-ms-fill-upper {
      background: transparent;
    }
  }
}